export default __webpack_public_path__ + "static/media/unsure.321495ff.png";